/**
* 添加售后
*/
<template>
	<div style="display: flex;flex-direction: column; height: 100vh; padding: 20px;">

		<el-page-header @back="goBack" content="添加售后">
		</el-page-header>

		<!-- 选择设备类型 -->
		<el-form ref="form" label-width="150px" style="margin-top: 30px;">
			<el-form-item label="请选择售后设备类型">
				<el-select v-model="typeId" clearable placeholder="请选择" @change="select">
					<!-- 1 cellmate  pearFlower  3 little devil  4 7 二代锁  6 钥匙盒  5 拍子  9 肛塞 10三代锁 -->
					<el-option label="一代锁" value="1"></el-option>
					<el-option label="梨花肛塞" value="2"></el-option>
					<el-option label="小恶魔" value="3"></el-option>
					<el-option label="二代锁(旧图标)" value="4"></el-option>
					<el-option label="电击拍" value="5"></el-option>
					<el-option label="一代钥匙盒" value="6"></el-option>
					<el-option label="二代锁(新图标)" value="7"></el-option>
					<el-option label="二代肛塞" value="9"></el-option>
					<el-option label="三代锁" value="10"></el-option>
				</el-select>
			</el-form-item>
		</el-form>

		<!-- 上传资料 -->
		<span style="font-size: 14px; color: #5d5d5d; margin-left: 15px;">上传设备损坏图片</span>

		<!-- 上传图片 -->
		<el-upload style="padding-top: 10px; padding-bottom: 20px; margin-left: 15px;" action="http://baidu.com/"
			list-type="picture-card" :auto-upload="false" :file-list="fileList" :on-change="handleChange">
			<i slot="default" class="el-icon-plus"></i>
			<div slot="file" slot-scope="{file}">
				<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
						<i class="el-icon-zoom-in"></i>
					</span>
					<span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
						<i class="el-icon-delete"></i>
					</span>
				</span>
			</div>
		</el-upload>

		<!-- 图片展示 -->
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>

		<!-- 寄回地址 -->
		<span style="font-size: 14px; color: #5d5d5d; margin-left: 15px;">填写寄回地址</span>

		<!-- 填写寄回地址 -->
		<div style=" margin-left: 15px;  margin-top: 10px;">
			<el-input style="font-size: 14px; color: #5d5d5d;" type="textarea" :autosize="{ minRows: 6, maxRows: 10}"
				placeholder="填写设备寄回地址" v-model="returnAddress">
			</el-input>
		</div>

		<!-- 第一步提交 -->
		<div style="display: flex; justify-content: center; margin-top: 30px;">
			<el-button style="width: 60%;" type="success" @click="submit01()">提交</el-button>
		</div>


	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				typeId: "", //设备类型
				dialogImageUrl: '',
				dialogVisible: false,
				disabled: false,
				fileList: [], // 用于存储上传的文件列表(这里是浏览器中的缓存图片)
				returnAddress: "", //寄回地址
				//...
			};
		},
		methods: {
			submit01() { //提交检测结果 第一步

				//上传的图片
				for (let key in this.keyValuePairs) {
					if (this.keyValuePairs.hasOwnProperty(key)) {
						console.log(`Key: ${key}, Value: ${this.keyValuePairs[key]}`);
					}
				}

			},
			handleChange(file, fileList) { // 选择文件时触发
				this.fileList = fileList;

				const formData = new FormData(); // 创建一个 FormData 对象
				formData.append("multipart", file.raw); // 将文件添加到 FormData 对象中
				axios.post(this.$p_url_shop + '/api/front/upload/qiuiUploadImage?model=user&pid=1',
						formData, { //上传图片
							withCredentials: true,
							headers: {
								'Content-Type': 'multipart/form-data', //设置为上传文件的类型
							},
						})
					.then(response => {
						console.log("上传图片的返回：", response.data)
						const state = response.data.code; // 获取状态
						if (state === 200) { // 检查状态
							this.newKey = file.url;
							this.newValue = response.data.data.url;
							this.$set(this.keyValuePairs, this.newKey, this.newValue); // 添加新的键值对
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert('请求失败:' + error);
						console.error('Error fetching data:', error);
					});


			},
			handleRemove(file) { //删除图片
				console.log(file);

				const imageUrl = file.url; // 获取要删除的图片的 URL
				const imageKey = Object.keys(this.keyValuePairs).find(key => {
					const isMatch = key === imageUrl;
					return isMatch;
				});
				if (imageKey) { // 如果找到了对应的键
					const name = this.keyValuePairs[imageKey];
					console.log("对应的值:", name);

					const formData = new FormData(); // 创建一个 FormData 对象
					formData.append("imageName", name); //图片的路径
					axios.post(this.$p_url_shop + '/api/front/upload/deleteOssImage',
							formData, {
								withCredentials: true,
								headers: {
									'Content-Type': 'application/json',
									'Accept': '*/*',
								},
							})
						.then(response => {
							console.log("删除图片的返回：", response.data)
							const state = response.data.code;
							if (state === 200) {
								this.$delete(this.keyValuePairs, file.url); // 删除指定键的键值对

								// 更新 fileList，移除被删除的图片
								const index = this.fileList.indexOf(file);
								if (index !== -1) {
									this.fileList.splice(index, 1);
								}

							} else {
								alert("服务器错误:" + response.data.message)
							}
						})
						.catch(error => { // 请求失败时处理错误
							alert('请求失败:' + error);
							console.error('Error fetching data:', error);
						});
				}


			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			select() { //选中的设备类型
				console.error('选中的设备类型:', this.typeId);
			},
			goBack() { //返回上一页
				this.$router.go(-1); // 返回到上一个路由
			}
			//...
		},
		//...

	}
</script>

<style>
</style>